import React, { 
    Component,
    PropTypes,
} from 'react'
import CountUp from 'react-countup'

class ProfileCard extends React.Component{
  shouldComponentUpdate(nextProps, nextState) {
    let idEqual = _.isEqual(nextProps.data.id, this.props.data.id)
    let positionEqual = _.isEqual(nextProps.position, this.props.position)
    return !(idEqual && positionEqual)
  }

  render() {
    let {
      data,
      order,
      position,
      nextPosition,
      prevPosition
    } = this.props
    let className
    let display = true
    switch(order){
    case position:
      className = 'is-active'
      break
    case nextPosition:
      className = 'is-next'
      break
    case prevPosition:
      className = 'is-prev'
      break
    default:
      display = false
      className = ''
      break
    }
    if(!display){
      return <div className={`profile-card profile-${order} hide ${className}`}></div>
    }
    return <div className={`profile-card profile-${order} ${className}`}>
      <div className='avatar'>
        <img src={data.photo}/>
      </div>
      <div className='information'>
        <div className='title'>{data.title}</div>
        <div className='name'>{data.name}</div>
        <div className='metrics'>
          <i className={`icon icon-${data.media}`}></i>
          <div className='label'>{data.label}</div>
          <div className='count-up'>
            <CountUp 
              start={data.follower} 
              end={data.follower + _.random(1000, 1500)}
              duration={_.random(2000, 15000)}
              useEasing={true}
              useGrouping={true}
              separator=","/>
          </div>
        </div>
      </div>
    </div>
  }
}

module.exports = ProfileCard



/** WEBPACK FOOTER **
 ** assets/javascripts/introduction/profile_card.js
 **/